





































import { Component, Prop, Vue } from "vue-property-decorator";
import { ButtonVariant, Party } from "@/types";
import PageContainer from "@/components/PageContainer.vue";
import { createPartyPage, joinPartyPage, partyLinkPage } from "@/router";
import SmallContainer from "@/components/SmallContainer.vue";
import { jitsiRoomUrl } from "@/utils/url";

@Component({
  components: { SmallContainer, PageContainer }
})
export default class PartyLinkPage extends Vue {
  $enums = {
    ButtonVariant
  };

  @Prop({ required: true }) party!: Party;

  get jitsiRoomUrl(): string {
    return jitsiRoomUrl(this.party);
  }

  get shareLink(): string {
    return (
      window.location.origin +
      this.$router.resolve(partyLinkPage(this.party)).href
    );
  }

  joinParty(): void {
    this.$router.push(joinPartyPage(this.party));
  }

  goToCreatePage(): void {
    this.$router.push(createPartyPage());
  }
}
